<app-open-item-list *ngIf="isSgProduct"></app-open-item-list>
<mf-hk-open-item-list *ngIf="isHkProduct"></mf-hk-open-item-list>
